import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { SettingsLabel } from '../styles';
import { Description, Space } from './custom-domain.styles';

export const DefaultDomain: FC<{ url: string }> = ({ url }) => (
  <Space size={4}>
    <SettingsLabel>
      <FormattedMessage id="settings.custom_domain.default.title" />
    </SettingsLabel>
    <Space size={4}>
      <LinkButton href={`http://${url}`} target="_blank">
        {' '}
        {url}
      </LinkButton>
      <Description>
        <FormattedMessage id="settings.custom_domain.default.description" />
      </Description>
    </Space>
  </Space>
);
